export default [
  {
    name: 'Le mie Storie',
    id: 2,
    parentId: 0,
    rootName: ['Folders', 'PodcastsSectionRoot', 'PodcastsSection', 'Podcasts'],
    submenu: [
      {
        url: $route => ({
          name: 'Folders',
          params: {
            tenant: $route.params.tenant,
          },
          query: {},
        }),
        name: 'Tutte le storie',
        id: 21,
        parentId: 2,
        active: [
          'Folders',
          'PodcastsSectionRoot',
          'PodcastsSection',
          'Podcasts',
        ],
      },
      {
        url($route) {
          if ($route.name === 'Folders') {
            return {
              name: $route.name,
              params: $route.params,
              query: {
                status: 'draft',
              },
            }
          }

          return {
            name: 'Folders',
            params: {
              tenant: $route.params.tenant,
            },
            query: {
              status: 'draft',
            },
          }
        },
        name: 'Bozze',
        id: 22,
        parentId: 2,
      },
      {
        url($route) {
          if ($route.name === 'Folders') {
            return {
              name: $route.name,
              params: $route.params,
              query: {
                status: 'publish',
              },
            }
          }

          return {
            name: 'Folders',
            params: {
              tenant: $route.params.tenant,
            },
            query: {
              status: 'publish',
            },
          }
        },
        name: 'Pubblicate',
        id: 22,
        parentId: 2,
      },
    ],
  },
  {
    name: 'Impostazioni',
    id: 3,
    parentId: 0,
    rootName: ['Settings', 'SettingsSeo', 'SettingsAnalytics', 'SettingsShare'],
    submenu: [
      {
        url: $route => ({
          name: 'SettingsAnalytics',
          params: {
            tenant: $route.params.tenant,
          },
        }),
        name: 'Analytics',
        id: 31,
        parentId: 3,
      },
      {
        url: $route => ({
          name: 'SettingsSeo',
          params: {
            tenant: $route.params.tenant,
          },
        }),
        name: 'SEO',
        id: 32,
        parentId: 3,
      },
      {
        url: $route => ({
          name: 'SettingsShare',
          params: {
            tenant: $route.params.tenant,
          },
        }),
        name: 'Opzioni di Condivisione',
        id: 34,
        parentId: 3,
      },
    ],
  },
  {
    name: 'Area Personale',
    id: 4,
    parentId: 0,
    rootName: ['Profile'],
    submenu: [
      {
        url: $route => ({
          name: 'Profile',
          params: {
            tenant: $route.params.tenant,
          },
        }),
        name: 'Il mio profilo',
        id: 41,
        parentId: 4,
      },
      {
        url: $route => ({
          name: 'Logout',
          params: {
            tenant: $route.params.tenant,
          },
        }),
        name: 'Logout',
        id: 42,
        parentId: 4,
      },
    ],
  },
  {
    name: 'Gestione Utenti',
    id: 5,
    parentId: 0,
    rootName: ['Users', 'EditUser', 'NewUser'],
    isAdmin: true,
    submenu: [
      {
        url: $route => ({
          name: 'Users',
          params: {
            tenant: $route.params.tenant,
          },
        }),
        name: 'Tutti gli utenti',
        id: 51,
        parentId: 5,
        isAdmin: true,
      },
    ],
  },
  // {
  //   url: '/#',
  //   name: 'Gestione Istanze',
  //   id: 6,
  //   parentId: 0,
  // },
]
